// axios
import axios from 'axios'

 

export const axiosConfig = {  
   //baseURL: 'http://localhost:443/portailcogepha'
    //baseURL: 'http://192.168.4.165:443/portailcogepha'
    baseURL: 'http://41.227.31.124:443/portailcogepha'
}
 
export default axios.create({
 // baseURL: 'http://localhost:443/portailcogepha'
  //baseURL: 'http://192.168.4.165:443/portailcogepha'
  baseURL: 'http://41.227.31.124:443/portailcogepha'
 
})
 
